export const ACTION_TYPES = {
    PAUSE: 'pause',
    RESUME: 'resume',
}

export const ACTION_TYPES_TITLE = {
    [ACTION_TYPES.PAUSE]: 'Pause automated exceptions',
    [ACTION_TYPES.RESUME]: 'Resume automated exceptions',
}

export const MODAL_TITLES = {
    [ACTION_TYPES.PAUSE]: 'Pause automated exceptions?',
    [ACTION_TYPES.RESUME]: 'Resume automated exceptions?',
}

export const MODAL_BODY_MESSAGES = {
    [ACTION_TYPES.PAUSE]:
        'Pausing automated exceptions for this job will prevent any on-time exception records from being created or escalated to failure status, even in the event that milestones are missed. Are you sure you want to pause automated exception management for this job?',
    [ACTION_TYPES.RESUME]:
        "Resuming automated exceptions for this job will trigger the creation and escalation of any on-time exception records warranted by the job's performance against the job's milestones. Are you sure you want to resume automated exception management for this job?",
}

export const BUTTON_TITLE = {
    [ACTION_TYPES.PAUSE]: 'Pause exceptions',
    [ACTION_TYPES.RESUME]: 'Resume exceptions',
}
